import { render } from "./BlankCanvas.vue?vue&type=template&id=3413bbc5"
import script from "./BlankCanvas.vue?vue&type=script&lang=js"
export * from "./BlankCanvas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/Misc/BlankCanvas.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3413bbc5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3413bbc5', __exports__)) {
    api.reload('3413bbc5', __exports__)
  }
  
  module.hot.accept("./BlankCanvas.vue?vue&type=template&id=3413bbc5", () => {
    api.rerender('3413bbc5', render)
  })

}


export default __exports__